import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ path, exact, children }) => {
  let user = localStorage.getItem("user");

  return user ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
